// @ts-nocheck

import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { useEventCenterNodeContext } from '../../contexts/EventCenterNodeContext';
import EventCenterAPI from '../../lib/eventCenter';

const Node = styled.div`
  margin: 0;
  width: 100%;
  height: 300px;
  margin: 0 auto;
  display: block;
`;

type EventCenterNodeProps = {
  className?: string;
  config: unknown;
};

const EVENT_CENTER_NODE_ID = 'event-center-node';

const EventCenterNode = ({ className = '', config }: EventCenterNodeProps) => {
  const { launchView, setLaunchView, routingChannel } = useEventCenterNodeContext();
  const eventCenterInstanceRef = useRef();
  const [hasInstanceBeenLoaded, setHasInstanceBeenLoaded] = useState(false);
  const launchViewRef = useRef();

  useLayoutEffect(() => {
    launchViewRef.current = launchView;
  }, [launchView]);

  useLayoutEffect(() => {
    if (!eventCenterInstanceRef.current) {
      const { MessageTopics } = EventCenterAPI.eventCentreUtils;
      const finalConfig = {
        ...config,
        targetElementSelector: `#${EVENT_CENTER_NODE_ID}`,
      };

      if (launchViewRef.current) {
        finalConfig.initialContext = {
          view: launchViewRef.current,
        };
      }

      eventCenterInstanceRef.current = EventCenterAPI.eventCentre(finalConfig);

      eventCenterInstanceRef.current.on(MessageTopics.APP_LOADED, () => {
        setHasInstanceBeenLoaded(true);
      });
    }
  }, [config]);

  useEffect(() => {
    if (hasInstanceBeenLoaded) {
      const { MessageTopics } = EventCenterAPI.eventCentreUtils;

      const subcriptionId = routingChannel.subscribe((routingOptions) => {
        eventCenterInstanceRef.current?.emit(MessageTopics.CONTEXT_UPDATE, routingOptions);
      });

      return () => {
        if (subcriptionId) {
          routingChannel.unsubscribe(subcriptionId);
        }
      };
    }
  }, [hasInstanceBeenLoaded, routingChannel]);

  useEffect(() => {
    return () => {
      if (setLaunchView) {
        setLaunchView(null);
      }
    };
  }, [setLaunchView]);

  return <Node className={className} id={EVENT_CENTER_NODE_ID} />;
};

export default EventCenterNode;
